import { TypographyProps } from '@mui/material';
import React from 'react';

import { HeadlineMediumStyled } from './styles';

export const HeadlineMedium: React.FC<TypographyProps> = (props) => {
  return (
    <HeadlineMediumStyled variant="h2" {...props}>
      {props.children}
    </HeadlineMediumStyled>
  );
};
